import { getPriceItemPage, operateCacheProductPriceRel } from '@/services/product'
import { apiData2Table } from '@/utils/data'
import { useUpdateEffect } from 'ahooks'
import { Button, message } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { SLowcodeList } from 'shj-components'
import { useStore, useAtomValue, useAtom, useSetAtom } from 'jotai'
import { step1DataAtom } from '../../store';

export default forwardRef(function TableList(props: any, ref) {
  const { costType, budgetTypeId, setTabSourceObj, productId, packModelId, budgetTypeIdStr, costTypeStr } = props
  const [joinList, setJoinList] = useState<any>([])
  const [total, setTotal] = useState<any>({ [costType]: 0 })
  const listRef = useRef<any>()
  const [step1Data, setStep1Data] = useAtom(step1DataAtom);

  useUpdateEffect(() => {
    listRef.current?.reset()
  }, [costType, budgetTypeId])

  const fetchList = values => {
    const { current, pageSize, query } = values
    query.costType = costType // 费用项类型
    query.quoteType = budgetTypeId // 报价类型
    query.productId = productId
    query.enabled = true;
    query.orderBys = [
      {
        columnName: 'id',
        asc: false,
      },
    ]
    query.parentId = '0'
    return new Promise((resolve, reject) => {
      getPriceItemPage({params: {pageId: current, pageSize}, data: {...query, searchFlag: true}})
        .then(res => {
          res?.list?.forEach(item => {
            const index = step1Data.priceItems?.findIndex((price: any) => price.busId === item.id && price.quoteType === budgetTypeId && price.costType === item.costType);
            if (index !== -1) {
              item.joinFlag = true;
            }
          })
          resolve(apiData2Table(res))
          setTotal({ [costType]: res.list.length })
        })
        .catch(reject)
    })
  }
  const config = {
    name: '',
    rowSelection: false,
    columns: [
      {
        title: '费用项',
        dataIndex: 'itemName',
        width: 160,
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 120,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    search: [],
    footer: [],
    batchActions: [],
  }
  const formatRecord = (record, level) => {
    if (record.children) {
      const childrenList = record.children?.map((child: any) => formatRecord(child, level + 1));
      return {
        ...record,
        children: [...childrenList],
        busId: record.id,
        quoteType: budgetTypeId,
        quoteTypeName: budgetTypeIdStr,
        costTypeStr,
        level,
      }
    }
    return {
      ...record,
      busId: record.id,
      quoteType: budgetTypeId,
      quoteTypeName: budgetTypeIdStr,
      costTypeStr,
      level,
    }
  }
  const joinToTable = record => {
    const data = listRef.current.getDataSource()
    data.forEach(item => {
      if (item.id === record.id) {
        item.joinFlag = true
      }
    })
    listRef.current.updateDataSource([...data], total.costType)
    // 加入 删除费用项
    const priceItems: any = [...step1Data.priceItems];
    const newRecord = formatRecord(record, 1);
    priceItems.push({...newRecord });
    setStep1Data({
      ...step1Data,
      priceItems: [...priceItems]
    });
  }

  const deleteToTable = record => {
    const data = listRef.current.getDataSource()
    data.forEach(item => {
      if (item.id === record.id) {
        item.joinFlag = false
      }
    })
    const priceItems: any = [...step1Data.priceItems];
    const newPrice = priceItems.filter(price => !(price.busId === record.id && price.costType === record.costType && price.quoteType === budgetTypeId));
    setStep1Data({
      ...step1Data,
      priceItems: [...newPrice]
    });
  }
  useImperativeHandle(ref, () => {
    return {
      joinList,
    }
  }, [joinList])
  const extensions = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      actionRender(v, record: Record<string, any>) {
        return record.joinFlag ? (
          <Button
            type="link"
            onClick={() => {
              deleteToTable(record)
            }}
          >
            取消加入
          </Button>
        ) : (
          <Button
            type="link"
            onClick={() => {
              joinToTable(record)
            }}
          >
            加入
          </Button>
        )
      },
    },
  }
  return <SLowcodeList ref={listRef} searchMode="group"  paginationStyle="revert" config={config} {...extensions} />
})
